import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'shared/components/table/DataTable';
import { Title } from 'shared/components/abstract/interactables';

const columns = [
  {
    name: 'Ticket #',
    formatter: (row) => <Link to={`/ticket/view/${row.id}`}>{row.id}</Link>,
  },
  {
    name: 'Legacy #',
    jsonKey: 'legacy_id',
  },
  {
    name: 'Title',
    jsonKey: 'title',
    formatter: (row) => row.title,
  },
];

const legacyIdSearch = (search) => {
  const sp = new URLSearchParams(search);
  const id = sp.get('q');
  sp.delete('q');
  sp.set('legacy_id', id);
  return {
    path: `tickets?${sp.toString()}`,
  };
};

export default function LegacyTicketSearch() {
  return (
    <>
      <Title title="Tickets" />
      <DataTable
        columns={columns}
        searchRequest={legacyIdSearch}
        className="table-height-large"
        rowId="id"
        noExportButton
      />
    </>
  );
}
